module.exports = {
  i18n: {
    defaultLocale: 'en-us',
    locales: ['en-us', 'en-gb', 'en-ca', 'fr-ca', 'en-au', 'fr-fr', 'en-nl', 'en-it', 'en-sa', 'en-de'],
  },
};
